/**
 * Generated by `cargo test -p videas-core --test suites catalog_ts`, which `bun run api:sync` runs.
 * Do not edit by hand: the next run reverts the patch.
 *
 * The prices the frontends show, out of `videas_core::billing::catalogue` — the list
 * `videas migrate` reconciles into `services` and `pricing_tiers`, whose figures are the
 * Astro corporate site's (docs/plans/billing-ledger.md D16, O13). Every amount is in euro
 * cents excluding tax: the wallet counts euros, and "credit" names the balance, not a unit
 * (O8). Display and estimation only — the debit is the backend's.
 *
 * The estimation assumptions that are not prices are in `./assumptions.ts`, written by hand.
 */

/** The day the newest tariff in this file took effect. */
export const PRICING_VERSION = '2026-10-23'

/** Monthly fee of a channel, in cents (`websites.channel_monthly`). */
export const CHANNEL_MONTHLY_CENTS = 1000

/** Monthly fee of a custom domain attached to a channel, in cents (`websites.domain_monthly`). */
export const CUSTOM_DOMAIN_MONTHLY_CENTS = 1000

/**
 * Free credit granted every month, in cents. Each grant expires when the next one lands, so
 * the wallet never holds two (O8). A new platform's default: the server's is per platform.
 */
export const FREE_MONTHLY_GRANT_CENTS = 500

/**
 * Free credit granted at signup, in cents: the first monthly grant, landing on the day the
 * organization is created and expiring with the next one — not a second kind of grant (O8).
 */
export const SIGNUP_FREE_CREDITS_CENTS = 500

/** Delivery included every month at no charge, in GB (`bandwidth.delivered`'s band priced at zero). */
export const FREE_BANDWIDTH_GB = 1000

export type UsageSkuKey = 'video_storage' | 'file_storage' | 'bandwidth' | 'subtitles'
export type UsageUnit = 'hour' | 'gb' | 'minute'

export interface UsageSku {
  key: UsageSkuKey
  /** Price per unit, in cents. */
  unitCents: number
  unit: UsageUnit
  /** Billed every month it goes on being used (a daily meter), rather than per use. */
  recurring: boolean
}

/** The metered and per-use prices; delivery's is the price past the free allowance. */
export const USAGE_SKUS: UsageSku[] = [
  { key: 'video_storage', unitCents: 20, unit: 'hour', recurring: true },
  { key: 'file_storage', unitCents: 5, unit: 'gb', recurring: true },
  { key: 'bandwidth', unitCents: 2, unit: 'gb', recurring: true },
  { key: 'subtitles', unitCents: 10, unit: 'minute', recurring: false },
]

/** Reload bonus tiers: a top-up of `amountCents` grants `bonusPercent`% extra credits. */
export interface ReloadBonusTier {
  amountCents: number
  bonusPercent: number
}

/**
 * First-paint copy of the reload bonus tiers — a new platform's defaults, NOT the source of
 * truth: the server grants the bonus from the platform's own tiers, and `useReloadBonus()`
 * replaces these once it has asked.
 */
export const RELOAD_BONUS_TIERS: ReloadBonusTier[] = [
  { amountCents: 2500, bonusPercent: 5 },
  { amountCents: 5000, bonusPercent: 10 },
  { amountCents: 10000, bonusPercent: 15 },
  { amountCents: 25000, bonusPercent: 18 },
  { amountCents: 50000, bonusPercent: 20 },
  { amountCents: 100000, bonusPercent: 25 },
]
